import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Hook from './components/Hook';
import Services from './components/Services';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Hook />
        <Services />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
